module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label three"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Montant")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "text",
      "name": "montant"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.currencies,
      "selected": _vm.currency
    },
    on: {
      "change": function($event) {
        _vm.currency = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "label input-like small"
  }, [_vm._v("\n\t\t\t\tPériodicité\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.type,
      "values": _vm.periods
    },
    on: {
      "change": function($event) {
        _vm.type = $event
      }
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asterisk-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("\n\t\t\tQuel est le montant que vous estimez nécessaire pour maintenir votre équilibre de vie ? (facultatif)\n\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93d6bd48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/SpendingNoTaxes.vue
// module id = 1160
// module chunks = 0